export const HOME_FLOAT_ACTION_ID = 'App:FloatActionArea'
